import { render, staticRenderFns } from "./draft.vue?vue&type=template&id=0a7135f2&scoped=true"
import script from "./draft.vue?vue&type=script&lang=js"
export * from "./draft.vue?vue&type=script&lang=js"
import style0 from "./draft.vue?vue&type=style&index=0&id=0a7135f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7135f2",
  null
  
)

export default component.exports